import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { useTheme } from '../contexts/ThemeContext';

export default function QualityBreakdownPieChart({ data }) {
    const { theme } = useTheme();
    const darkMode = theme === 'dark';
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    const getChartOption = (darkMode) => {
        return {
            backgroundColor: 'transparent',
            tooltip: {
                trigger: 'item',
                formatter: '{b}: {c} ({d}%)'
            },
            legend: {
                orient: 'horizontal',
                bottom: 0,
                textStyle: {
                    color: darkMode ? '#f9fafb' : '#111827'
                }
            },
            series: [
                {
                    name: 'Quality Breakdown',
                    type: 'pie',
                    radius: ['40%', '70%'], // donut style
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 8,
                        borderColor: darkMode ? '#1f2937' : '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: true,
                        formatter: '{b}\n{d}%',
                        color: darkMode ? '#f9fafb' : '#111827'
                    },
                    labelLine: {
                        show: true
                    },
                    data: [
                        { value: data.Personal, name: 'Personal' },
                        { value: data.Other, name: 'Other' },
                        { value: data.Invalid, name: 'Invalid' },
                        { value: data.Business, name: 'Business' }
                    ]
                }
            ]
        };
    };

    // Init chart
    useEffect(() => {
        chartInstance.current = echarts.init(chartRef.current, null, { renderer: 'svg' });
        chartInstance.current.setOption(getChartOption(darkMode));

        const handleResize = () => chartInstance.current?.resize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            chartInstance.current?.dispose();
        };
    }, []);

    // Update chart on theme/data change
    useEffect(() => {
        if (chartInstance.current) {
            chartInstance.current.setOption(getChartOption(darkMode), true);
        }
    }, [darkMode, data]);

    return <div ref={chartRef} style={{ width: '100%', height: '400px' }} />;
}
